var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs-items',{attrs:{"elevation":"0"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},_vm._l((_vm.items),function(item){return _c('v-tab-item',{key:item.name},[_c(item.name,{tag:"component"}),_vm._v(" "),(item.hasActions)?_c('dms-users-form-actions',{attrs:{"my-profile":true}}):_vm._e()],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }